import React from 'react';
import blueWave from './blue-wave.svg';

function Wave() {
  return <div className="cover-background" style={{ backgroundImage: `url(${blueWave}` }} aria-hidden="true" />;
}

export default Wave;
